const appInfo = {
     title: 'Report TouchSoft'
};
export default appInfo;

